import { render, staticRenderFns } from "./Stack.vue?vue&type=template&id=07b8a8fe&functional=true&"
import script from "./Stack.vue?vue&type=script&lang=ts&"
export * from "./Stack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports